var ADSEARCH = {};
ADSEARCH.TYPE_CATEGORY    = "category";
ADSEARCH.TYPE_ROOT        = "root";
ADSEARCH.TYPE_SET         = "set";
ADSEARCH.TYPE_ATTR        = "attr";
ADSEARCH.TYPE_OTHER       = "other";
ADSEARCH.TYPE_CONFIG      = "config";
ADSEARCH.TYPE_RANGES      = "ranges";
ADSEARCH.TYPE_NUMERIC     = "numeric";
ADSEARCH.TYPE_FORMATS     = "formats";
ADSEARCH.TYPE_HIERARCHIES = "hierarchies";
ADSEARCH.TYPE_LINKS       = "links";
ADSEARCH.ATTR_PREFIX      = "prefix";
ADSEARCH.ATTR_SUFFIX      = "suffix";
ADSEARCH.ATTR_DELIM       = "delim";
ADSEARCH.ATTR_SHOW        = "show";
ADSEARCH.ATTR_PARENT      = "parent";
ADSEARCH.ATTR_TYPE        = "type";
ADSEARCH.ATTR_FUNC        = "func";
ADSEARCH.ATTR_SORT        = "sort";
ADSEARCH.VAL_ONCLICK      = "onclick";
ADSEARCH.VAL_HREF         = "href";
ADSEARCH.SELECT_PREFIX    = "sel_";
ADSEARCH.CHECKBOX_PREFIX  = "chk_";
ADSEARCH.DIV_PREFIX       = "div_";
ADSEARCH.RANGE_PREFIX     = "range";
ADSEARCH.RANGE_SEP        = "_";
ADSEARCH.AVAIL_FACETS_ID  = ADSEARCH.SELECT_PREFIX + "avail_facets";
ADSEARCH.FACET_VALUE_ID   = ADSEARCH.SELECT_PREFIX + "facet_values";
ADSEARCH.FACET_VALUES_DIV = ADSEARCH.DIV_PREFIX + "facet_values";
ADSEARCH.SUBMIT_TEXT      = "Submit";
ADSEARCH.SELECT_TEXT      = "Select";
ADSEARCH.CHOOSE_TEXT      = "Choose";
ADSEARCH.REMOVE_TEXT      = "Click to remove this restriction";
ADSEARCH.NS_ATTR          = "__ns__";
ADSEARCH.NS_TEXT          = "Not Specified";

ADSEARCH.PREF_INVALID_CAT_VALS = "hide"; // ("disable" or "hide")

ADSEARCH.eventElem = null;

ADSEARCH.xmlDoc = null;
ADSEARCH.rootNode = null;

ADSEARCH.chooseValueLock = false;

ADSEARCH.keyTimeout = null;

function resetAdsearchDefaults()
{
  ADSEARCH.query = { 'levels' : [],
                     'attrGroups' : [] };

  ADSEARCH.validVals = null
  ADSEARCH.catValidVals = null;
}

// Call the reset function initially.
resetAdsearchDefaults();


/*
  This function is simply to send the request for the XML file, 
  and associate a callback to handle the XML response.  This
  function should be called on page load.
*/
function getIndexFile()
{
  var rcgIndexURL = constructURL( "adsearch_get_config",
                                  { "file": "rcg_index.xml" },
                                  menuManager.getLocCGI_Main(),
                                  "rcg_index.xml" ),
      searchConfigURL = constructURL( "adsearch_get_config",
                                      { "file": "search_config.xml" },
                                      menuManager.getLocCGI_Main(),
                                      "search_config.xml" );
  doSimpleXMLHttpRequest( rcgIndexURL ).addCallback( loadIndexFile );
  doSimpleXMLHttpRequest( searchConfigURL ).addCallback( loadConfigFile );
}
addLoadEvent(getIndexFile);

/*
  Allow users to submit searches by pressing enter in the text search box
*/
addLoadEvent(function(){connect($('textsrch'),"onkeyup",checkKeyPress);});


/*
  This is the callback function to hanlde loading the XML file.
  Once succesfully loaded, it will pass the root node to the 
  processChildNodes function
*/
function loadIndexFile(res)
{
  if(isUndefinedOrNull(res.responseXML))
  {
    scs_alert("ERROR_INIT_SEARCH");
    return;
  }

  var xmlDoc = res.responseXML;

  var rootNodes = xmlDoc.getElementsByTagName(ADSEARCH.TYPE_ROOT);
  if(rootNodes.length != 1)
  {
    scs_alert("ERROR_INIT_SEARCH");
    return;
  }

  ADSEARCH.xmlDoc = xmlDoc;
  ADSEARCH.rootNode = rootNodes[0];
  processNode(ADSEARCH.rootNode, false);
  updateSelectedFacets();
}

function loadConfigFile(res)
{
  if(isUndefinedOrNull(res.responseXML))
  {
    scs_alert("ERROR_INIT_SEARCH");
    return;
  }

  var xmlDoc = res.responseXML;

  var rootNodes = xmlDoc.getElementsByTagName(ADSEARCH.TYPE_CONFIG);
  if(rootNodes.length != 1)
  {
    scs_alert("ERROR_INIT_SEARCH");
    return;
  }

  ADSEARCH.configXMLDoc = xmlDoc;
}

/*
  Simple wrapper function to process all of my children 
*/
function processChildNodes(node)
{
  forEachElementChildNode(node, processNode);
}

/*
  Wrapper function needed when in LEFT_BODY layout to determine 
  which node we're currently at
*/
function processNodeWrapper(e)
{
  var n = isUndefinedOrNull;
  ADSEARCH.eventElem = e.src();
  var node;
  if( ADSEARCH.eventElem.tagName == "A" &&
      hasElementClass( ADSEARCH.eventElem, "scs_sprite" ) ) {
    var setId = getNodeAttribute( ADSEARCH.eventElem.parentNode, "scs:set" );
    node = getElementByIdXML(ADSEARCH.rootNode, setId, ADSEARCH.TYPE_CATEGORY);
    var c = getFirstElementChildNode(node);
    if(!n(node) && !n(c) && 
       node.parentNode.tagName === ADSEARCH.TYPE_ROOT && 
       c.tagName === ADSEARCH.TYPE_SET )
      { processNode(node, true); }
    else
      { processNode(node, false); }
  }
  else
  {
    //mbbhere - Change the attribute from scs:set to something more appropriate
    node = getElementByIdXML(ADSEARCH.rootNode, getNodeAttribute(ADSEARCH.eventElem.parentNode, "scs:set"), ADSEARCH.TYPE_CATEGORY);
    processNode(node, false);
  }
  ADSEARCH.eventElem = null;

  return false;
}

/*
  Handle a Category node in an RCG index file.  If this is not
  our final category, this will generate a select box, 
  containing all of the sub categories, from which the user
  must choose one.

  If we have reached our final category (i.e. this category
  has 'set' and 'other' children. not 'category' children), then
  we'll process them individually

  secondTime is used to indicate when this is our second time 
  through for a top level category leaf node:

    <root> 
      <catogory id="helpwanted">
        <set id="...">
          ...

  In this case, the first time through, we actually want to display 
  the helpwanted node as an expandable div, even though it has no 
  category children.  Once it's clicked and we are coming throug 
  here a second time, we then want to display the helpwanted node 
  as a link underneath the helpwanted expandable link.
*/
function processNode(node, secondTime)
{
  var n = isUndefinedOrNull;
  if(n(secondTime)) { secondTime = false; }
  var cats = getChildNodes(node, ADSEARCH.TYPE_CATEGORY);

  // If this is our second time through, need to override cats here
  if(secondTime) { cats = [ node ]; }

  if(n(cats) || cats.length == 0)
  {
    // We have reached the set nodes, handle them here
    var setNodes = node.getElementsByTagName(ADSEARCH.TYPE_SET);
    var otherNodes = node.getElementsByTagName(ADSEARCH.TYPE_OTHER);

    var arr = [];
    forEach(setNodes, function(s) { arr.push(s); });
    if(otherNodes.length > 0) { arr.push(otherNodes[0]); }

    if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_SINGLE_SELECT)
      { appendFacetSelectBox(node, arr);  }
    else if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_ROW_TAB)
      { appendRowOfFacets(node, arr); }
    else if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_LEFT_BODY)
      { appendFacetsToLeftBody(node, arr); }
  }
  else
  {
    // We are still traversing therough different categories, 
    // handle category nodes here
    var attr = getNodeAttribute;
    var node_id = attr(node, "id");

    if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_LEFT_BODY)
    {
      var parent = null;
      if(node.tagName == "root")
      {
        parent = $('upper_left_body');  
        replaceChildNodes( parent,
                           SPAN( { "style": "font-size: 1.05em" },
            "Please choose the category of ads you would like to search for:" ),
                           P() );
      }
      else
      {
        parent = $(node_id + "_sub");
        replaceChildNodes(parent);
      }

      forEach(cats, function(c)
      {
        var sub_div = DIV();
        var div;
        var c_attrs = getAttrObj(c);
        var gc = getFirstElementChildNode(c);
        if( ( ! isUndefinedOrNull( gc ) &&
              gc.tagName == ADSEARCH.TYPE_CATEGORY ) || 
            ( c.parentNode.tagName === ADSEARCH.TYPE_ROOT && !secondTime ) ) {
          div = getExpandableDiv(c_attrs.id,c_attrs.desc,sub_div,processNodeWrapper);
        }
        else
        {
          var a = A({'href':'#'}, c_attrs.desc);
          connect(a, "onclick", processNodeWrapper);
          div = DIV({'style':'float:left;clear:both;width:100%;'},null);
          appendChildNodes(div,a);
        }
        setNodeAttribute(div, "scs:cat", node_id);
        setNodeAttribute(div, "scs:set", c_attrs.id);
        appendChildNodes(parent,div);
                         
      });        
    }
    else
    {
      var selId = ADSEARCH.SELECT_PREFIX + 
                  ADSEARCH.TYPE_CATEGORY + "_" + node_id;

      var sel = SELECT( { 'id' : selId }, null);

      forEach(cats, function(c)
      {
        appendChildNodes(sel, OPTION({'value':getNodeAttribute(c,"id")},
                                     getNodeAttribute(c,"desc")));
      });

      // If we oly have one option, we're going to just 
      // choose that.
      if(sel.childNodes.length == 1)
      {
        submitCategoryFacet(getNodeAttribute(cats[0],"id"));
        processNode(cats[0], false);
      }
      else
      {
        replaceChildNodes($("current_searches"),
                          DIV({'class':'pl pt'},
                              getLabelSpan(node), 
                              sel, 
                              getSubmitButton(selId,
                                              ADSEARCH.SUBMIT_TEXT,
                                              submitFacet)));
      }
      return;
    }
  }
}

/*
  This function generates a select box of all available facets
  so the user can choose and add facet restrictions one at a time.
  When this select box is chosen, then the user is presented
  with another select box with all facet values for this facet.

  Note: only used when active layout is ADSEARCH.LAYOUT_FACET_SINGLE_SELECT
*/
function appendFacetSelectBox(node, setNodes)
{
  var attr = getNodeAttribute;
  var availSel = SELECT({'id':ADSEARCH.AVAIL_FACETS_ID, 
                         'scs:cat': attr(node,"id")}, null);

  forEach(setNodes, function(s)
  {
    appendChildNodes(availSel, 
                     OPTION({'value':attr(s,"id")},
                            attr(s,"desc")));
  });
 
  replaceChildNodes($('current_searches'), 
                    DIV(null, SPAN(null,"Please choose an attribute: "), 
                              availSel, 
                              getSubmitButton(ADSEARCH.AVAIL_FACETS_ID,
                                              ADSEARCH.SELECT_TEXT,
                                              chooseFacet)));
}

/*
  This function is called to generate the row of facets.  clicking on
  a facet will drop down a bunch of checkboxes with the facet values
  and allow the user to choose them.

  Note: Only used for the layout: ADSEARCH.LAYOUT_FACET_ROW_TAB;
*/
function appendRowOfFacets(node, setNodes)
{
  var attr = getNodeAttribute;
  var availDiv = DIV({'id':ADSEARCH.AVAIL_FACETS_ID, 
                      'class':'scs_center bb',
                      'scs:cat': attr(node,"id")}, null);

  forEach(setNodes, function(s)
  {
    var aNode = A( { 'href':'#','scs:value':attr(s,"id"),
                     'style':'text-decoration:none; font-weight:bold; color:blue; font-variant: small-caps;' }, 
                   attr(s,"desc") );
    connect(aNode, "onclick", chooseFacet);
    if(availDiv.childNodes.length > 0) 
      { appendChildNodes(availDiv, SPAN(null, " | ")); }
    appendChildNodes(availDiv, aNode);
  });
  replaceChildNodes($('current_searches'), availDiv);
}

/*
  This function is called to generate the drilldown listing of facets
  in the top of left body

  Note: Only used for the layout: ADSEARCH.LAYOUT_FACET_LEFT_BODY
*/
function appendFacetsToLeftBody(node, setNodes)
{
  var attr = getNodeAttribute;
  var availDiv = $('upper_left_body');

  // Determine the path taken to get to this leaf node
  var elem = ADSEARCH.eventElem.parentNode; // eventElem is the A and parentnode is the DIV
  var cat = attr(elem,"scs:set");
  var arr = [];
  var node_attrs = getAttrObj(node);

  while(!isUndefinedOrNull(cat) && cat != "")
  {
    var newNode = getElementByIdXML(ADSEARCH.rootNode, cat, ADSEARCH.TYPE_CATEGORY);
    var newNode_attrs = getAttrObj(newNode);
    arr.push({'id':newNode_attrs.id, 'desc':newNode_attrs.desc});
    cat = null;
    if(elem.parentNode && elem.parentNode.parentNode)
    { 
      elem = elem.parentNode.parentNode;
      cat = attr(elem, "scs:set");
    } 
  }

  ADSEARCH.query.levels = [];
  while(arr.length > 0)
  {
    var item = arr.pop();
    if ( objIndexOf( ADSEARCH.query.levels, "id", item.id ) < 0 )
     { ADSEARCH.query.levels.push(item); }
  }

  replaceChildNodes(availDiv);
  setNodeAttribute(availDiv, "scs:cat", node_attrs.id);
  appendChildNodes( availDiv,
                    SPAN( { "style": "font-size: 1.05em;" },
           "Please choose the attributes for your ad in the chosen category." ),
                    P() );

  forEach(setNodes, function(s)
  {
    var s_attrs = getAttrObj(s);
    var sub_div = DIV();
    var sprite = getExpandableDiv(s_attrs.id,s_attrs.desc,sub_div, chooseFacet);
    setNodeAttribute(sprite, "scs:cat", node_attrs.id);
    setNodeAttribute(sprite, "scs:set", s_attrs.id);
    appendChildNodes(availDiv, sprite);
  });

  updateSelectedFacets(true);
}

/*
  Execute when the user chooses a category from the select box.  
  This will call the appropriate child category node for the selected
  facet
*/
function submitFacet(e)
{
  ADSEARCH.eventElem = e.src();
  var id = getNodeAttribute(ADSEARCH.eventElem,"scs:for");
  
  if( id.indexOf(ADSEARCH.SELECT_PREFIX + 
                 ADSEARCH.TYPE_CATEGORY) >= 0 )
  {
    var catVal = $(id).value;
    submitCategoryFacet(catVal);
    removeElement($(id).parentNode);
    var catNode = getElementByIdXML(ADSEARCH.rootNode, catVal, ADSEARCH.TYPE_CATEGORY);
    processNode(catNode, false);
  }
  ADSEARCH.eventElem = null;
}

/*
  Called when a user chooses a final facet value (eg a set node).
  This then generates the appropriate view for the user to 
  select the value for the set.
*/
function chooseFacet(e)
{
  ADSEARCH.eventElem = e.src(); // Elem is the button
  if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_SINGLE_SELECT)
  {
    chooseFacetSingleSelect();
  }
  else if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_ROW_TAB)
  {
    chooseFacetRowTab();
  }
  else if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_LEFT_BODY)
  {
    chooseFacetLeftBody();
  }

  stopEvent(e);
  ADSEARCH.eventElem = null;
}

/*
  Handles generating the select boxes when in LAYOUT_FACET_SINGLE_SELECT mode
*/
function chooseFacetSingleSelect()
{
  // Remove any existing facet value selects
  if(!isUndefinedOrNull($(ADSEARCH.FACET_VALUE_ID)))
  {
    removeElement($(ADSEARCH.FACET_VALUE_ID));
    removeElement($(ADSEARCH.FACET_VALUE_ID+"_btn"));
  }

  var selId = getNodeAttribute(ADSEARCH.eventElem,"scs:for");
  var catId = getNodeAttribute($(selId),"scs:cat");
  var catNode = getElementByIdXML(ADSEARCH.rootNode, catId, ADSEARCH.TYPE_CATEGORY);
  var setNode = getElementByIdXML(catNode, $(selId).value, [ADSEARCH.TYPE_SET,ADSEARCH.TYPE_OTHER]);

  var attr = getNodeAttribute;
  var valSel = SELECT({'id': ADSEARCH.FACET_VALUE_ID,
                       'scs:set':attr(setNode, "id"),
                       'scs:cat':attr(catNode, "id")}, null);
  forEachElementChildNode(setNode, function(c,i)
  {
    appendChildNodes(valSel, 
                     OPTION({'value':attr(c,"id")},
                            attr(c,"desc")));
  });

  appendChildNodes($(ADSEARCH.AVAIL_FACETS_ID).parentNode, 
                   "  ", 
                   valSel, 
                   getSubmitButton(ADSEARCH.FACET_VALUE_ID,
                                   ADSEARCH.CHOOSE_TEXT,
                                   chooseValue));
}

/*
  Handles generating the attribute checkboxes when in LAYOUT_FACET_ROW_TAB mode
*/
function chooseFacetRowTab()
{
  //We're using the horizontal row of facet links
  var attr = getNodeAttribute;
  var catId = attr(ADSEARCH.eventElem.parentNode,"scs:cat");
  var catNode = getElementByIdXML(ADSEARCH.rootNode, catId, ADSEARCH.TYPE_CATEGORY);
  var setNode = getElementByIdXML(catNode, attr(ADSEARCH.eventElem, "scs:value"), [ADSEARCH.TYPE_SET,ADSEARCH.TYPE_OTHER]);
  var setNode_attrs = getAttrObj(setNode);

  var tableDiv = $(ADSEARCH.FACET_VALUES_DIV);
  if(isUndefinedOrNull(tableDiv))
  { 
    tableDiv = DIV({ 'id':ADSEARCH.FACET_VALUES_DIV }, null);
    appendChildNodes($('current_searches'), tableDiv);
  }

  setNodeAttribute(tableDiv, "scs:set", setNode_attrs.id);

  replaceChildNodes(tableDiv);
  var table = TABLE({'style':'margin:auto;'}, null);
  var tbody = TBODY();

  var NUM_COLS = 4;
 
  var tr = TR();

  var selAll = A({'href':'#', 'style':'color:blue;'},"Select All");
  connect(selAll, "onclick", selectAllValues);
  var selNone = A({'href':'#', 'style':'color:blue;'},"Select None");
  connect(selNone, "onclick", selectNoValues);
  var close = A({'href':'#', 'style':'color:blue;'},"Close");
  connect(close, "onclick", closeValues);

  appendChildNodes(tr, TD({ 'class':'scs_center', 
                            'colspan':NUM_COLS }, 
                          selAll, " | ", selNone, " | ", close));

  appendChildNodes(tbody, tr);
    
  tr = TR();
  var count = 0;

  for(var i = 0; i < setNode.childNodes.length; i++)
  {
    var c = setNode.childNodes[i];
    if(c.nodeType == 1)
    {
      var c_attrs = getAttrObj(c);
      var td = TD();

      var checked = getQueryAttrIndex(getQuerySetIndex(setNode_attrs.id), attr(c_attrs.id)) >= 0;
      var chk = INPUT({'type':'checkbox', 
                       'value':c_attrs.id, 
                       'scs:set':setNode_attrs.id,
                       'scs:cat':catId,
                       'id':ADSEARCH.CHECKBOX_PREFIX + c_attrs.id }, null);

      simpleSetCheckbox(chk,checked);

      connect(chk, "onclick", chooseValue);
      var lbl = LABEL({'for':ADSEARCH.CHECKBOX_PREFIX + c_attrs.id},c_attrs.desc);
      appendChildNodes(td, chk, SPAN("  "), lbl);
      appendChildNodes(tr, td) ;
      count++;

      if(count == NUM_COLS) 
      {
        appendChildNodes(tbody, tr);
        tr = TR();
        count = 0;
      }
    }
  }
 
  if(count > 0 && count < NUM_COLS)
  {
    appendChildNodes(tbody, tr);
  }
 
  appendChildNodes(table, tbody);
  appendChildNodes(tableDiv,table);
}

/*
  Handles generating the checkboxes in left body when in LAYOUT_FACET_LEFT_BODY mode
*/
function chooseFacetLeftBody()
{
  var attr = getNodeAttribute;
  var catId = attr(ADSEARCH.eventElem.parentNode,"scs:cat"); // A -> DIV
  var setId = attr(ADSEARCH.eventElem.parentNode,"scs:set"); // A -> DIV
  var catNode = getElementByIdXML(ADSEARCH.rootNode, catId, ADSEARCH.TYPE_CATEGORY);
  var setNode = getElementByIdXML(catNode, setId, [ADSEARCH.TYPE_SET,ADSEARCH.TYPE_OTHER]);
  var setNode_attrs = getAttrObj(setNode);

  var tableDiv = $(ADSEARCH.eventElem.parentNode.id + "_sub");
  if(isUndefinedOrNull(tableDiv))
  {
    return;
  }

  setNodeAttribute(tableDiv, "scs:set", setNode_attrs.id);

  replaceChildNodes(tableDiv);

  // If we are doing a range input
  if(setIsRange(setId))
  {
    var minSpan = SPAN(null, "Minimum: ");
    var maxSpan = SPAN(null, "Maximum: ");
    var minSel = SELECT({'id' : ADSEARCH.SELECT_PREFIX + setId + "_min",
                         'scs:set'   : setNode_attrs.id,
                         'scs:cat'   : catId}, null);
    var maxSel = SELECT({'id' : ADSEARCH.SELECT_PREFIX + setId + "_max",
                         'scs:set'   : setNode_attrs.id,
                         'scs:cat'   : catId}, null);

    appendChildNodes(minSel, OPTION({'value':''}, "No Minimum"));
    appendChildNodes(maxSel, OPTION({'value':''}, "No Maximum"));

    var minVal = null;
    var maxVal = null;

    var index = getQuerySetIndex(setId);
    if(index >= 0)
    {
      var vals = ADSEARCH.query.attrGroups[index].vals;
      if(vals.length > 0)
      { 
        if(vals[0].desc.split(",")[0] == 0)
          { minVal = null; }
        else 
          { minVal = vals[0].id; }
                
        maxVal = vals[vals.length-1].id;
      }
    }

    forEachElementChildNode(setNode, function(c)
    {
      var c_attrs = getAttrObj(c);
      var range = c_attrs.desc.split(",");

      var minopts = {'value':c_attrs.id};
      var maxopts = {'value':c_attrs.id};

      if(minVal === c_attrs.id)
        { minopts.selected = "selected"; }
      if(maxVal === c_attrs.id)
        { maxopts.selected = "selected"; }

      if(range.length === 2)
      {
        if(range[0] != "0")
        {
           appendChildNodes(minSel, OPTION(minopts, getFormattedValue(setId, range[0], false)));
        }
                                
        if(range[1] !== "")
        {
          appendChildNodes(maxSel, OPTION(maxopts, getFormattedValue(setId, range[1], false)));
        }
      }
    });

    minSel.onchange = chooseValue;
    maxSel.onchange = chooseValue;

    appendChildNodes(tableDiv, 
                     TABLE(null, 
                           TBODY(null, 
                                 TR(null, TD(null,minSpan), TD(null,minSel)), 
                                 TR(null, TD(null,maxSpan), TD(null,maxSel)) ) ) );
  }
  else
  {
    var tbl_id = attr(tableDiv, "id");
    var selAll = A({'href':'#', 'style':'color:blue;','scs:target':tbl_id},"All");
    connect(selAll, "onclick", selectAllValues);
    var selNone = A({'href':'#', 'style':'color:blue;','scs:target':tbl_id},"None");
    connect(selNone, "onclick", selectNoValues);

    appendChildNodes(tableDiv, selAll, " | ", selNone, BR());

    var appendCheckbox = function(label, id, set, cat, checked, disabled)
    {
      if(isUndefinedOrNull(checked))  { checked = false; }
      if(isUndefinedOrNull(disabled)) { disabled = false; }

      var chk = INPUT({'type':'checkbox', 
                       'value':id, 
                       'scs:set':set,
                       'scs:cat':cat,
                       'id':ADSEARCH.CHECKBOX_PREFIX + id }, null);

      simpleSetCheckbox(chk,checked);
      connect(chk, "onclick", chooseValue);

      var lbl = LABEL({'for':ADSEARCH.CHECKBOX_PREFIX + id,'style':'white-space:nowrap;'},label);

      // Note: only for "other attributes" now
      if(disabled) 
      { 
        disableCheckbox(chk); 
        disableLabel(lbl);
      }

      appendChildNodes(tableDiv, chk, SPAN("  "), lbl, BR());
    }

    // Append a Not Specified input if we're a spanning set
    if(setNode_attrs.id != ADSEARCH.TYPE_OTHER)
    {
      var checked = false;
      var setIndex = getQuerySetIndex(setNode_attrs.id);
      if(setIndex >= 0)
        { checked = (ADSEARCH.query.attrGroups[setIndex].ns === true); }
            
      appendCheckbox(ADSEARCH.NS_TEXT, ADSEARCH.NS_ATTR, setNode_attrs.id, catId, checked, false);
    }

    var hideInvalidNodes = hideSetInvalidVals(setNode_attrs.id);

    // Append a checkbox for each attribute of the set
    forEachElementChildNode(setNode, function(c)
    {
      var c_attrs = getAttrObj(c);
      var checked = getQueryAttrIndex(getQuerySetIndex(setNode_attrs.id), c_attrs.id) >= 0;

      // Only consider this attribute if it's valid for the current category
      if(isCatValidVal(setNode_attrs.id, c_attrs.id))
      {
        var isValid =  isValidVal( setNode_attrs.id, c_attrs.id );

        if(setNode_attrs.id === ADSEARCH.TYPE_OTHER)
        {
          // For other nodes, we disable always
          appendCheckbox(c_attrs.desc, c_attrs.id, setNode_attrs.id, catId, checked, !isValid);
        }
        else if(!hideInvalidNodes || isValid)
        {
          // For spanning sets, we show as long as we're not hiding or it's valid
          appendCheckbox(c_attrs.desc, c_attrs.id, setNode_attrs.id, catId, checked, false);
        }
      }
      else if(ADSEARCH.PREF_INVALID_CAT_VALS == "disable")
      {
        // The site preference is to disable these
        appendCheckbox(c_attrs.desc, c_attrs.id, setNode_attrs.id, catId, checked, true);
      }
      else if(ADSEARCH.PREF_INVALID_CAT_VALS == "hide")
      {
        // The site preference is to hide these so do nothing
        noop();
      }
    });
  }
}

/*
  Called when a user chooses a value for a given spanning set or 
  'other' node.  This updates the vieqw ccordingly and launches 
  the AJAX request to update the number of ads found.
*/
function chooseValue(e, noUpdate, ignoreLock)
{
  var n = isUndefinedOrNull;
  if(n(ignoreLock)) { ignoreLock = false; }

  // If we're currently locked because we just chose 
  // another value, cancel the click and do nothing
  if(!ignoreLock && ADSEARCH.chooseValueLock) 
  { 
    stopEvent(e);
    return false; 
  }

  // Set a lock so we finish the ajax request for this 
  // value prior to starting another one
  ADSEARCH.chooseValueLock = true;

  if(n(noUpdate)) { noUpdate = false; }
  
  ADSEARCH.eventElem = getUnknownEventElement(e);
  
  if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_SINGLE_SELECT)
  {
    var selId = getNodeAttribute(ADSEARCH.eventElem,"scs:for");
    var catId = getNodeAttribute($(selId),"scs:cat");
    var setId = getNodeAttribute($(selId),"scs:set");
    var catNode = getElementByIdXML(ADSEARCH.rootNode, catId, ADSEARCH.TYPE_CATEGORY);
    var setNode = getElementByIdXML(catNode, setId, [ADSEARCH.TYPE_SET,ADSEARCH.TYPE_OTHER]);
  
    toggleQueryValue(catId,
                     getNodeAttribute(setNode,"id"),
                     $(selId).value, 
                     $(selId).options[$(selId).selectedIndex].text,
                     true);
    replaceChildNodes($('current_searches'));  
    processNode(catNode, false);
  }
  else if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_ROW_TAB)
  {
    var catId = getNodeAttribute(ADSEARCH.eventElem, "scs:cat");
    var setId = getNodeAttribute(ADSEARCH.eventElem, "scs:set");
    var attrId = getNodeAttribute(ADSEARCH.eventElem, "value");
    var catNode = getElementByIdXML(ADSEARCH.rootNode, catId, ADSEARCH.TYPE_CATEGORY);
    var setNode = getElementByIdXML(catNode, setId, [ADSEARCH.TYPE_SET,ADSEARCH.TYPE_OTHER]);
    var attrNode = getElementByIdXML(setNode, attrId, ADSEARCH.TYPE_ATTR);

    toggleQueryValue(catId,
                     getNodeAttribute(setNode,"id"),
                     attrId, 
                     getNodeAttribute(attrNode,"desc"),
                     ADSEARCH.eventElem.checked);
  }
  else if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_LEFT_BODY)
  {
    var catId = getNodeAttribute(ADSEARCH.eventElem, "scs:cat");
    var setId = getNodeAttribute(ADSEARCH.eventElem, "scs:set");
    var isRange = setIsRange(setId);
    var attrId = isRange ? ADSEARCH.eventElem.value : getNodeAttribute(ADSEARCH.eventElem, "value");
    var catNode = getElementByIdXML(ADSEARCH.rootNode, catId, ADSEARCH.TYPE_CATEGORY);
    var setNode = getElementByIdXML(catNode, setId, [ADSEARCH.TYPE_SET,ADSEARCH.TYPE_OTHER]);
    var attrNode = getElementByIdXML(setNode, attrId, ADSEARCH.TYPE_ATTR);

    if(isRange)
    {
      clearQuerySet(setId);
      var minSel = $(ADSEARCH.SELECT_PREFIX + setId + "_min");
      var maxSel = $(ADSEARCH.SELECT_PREFIX + setId + "_max");

      if( !n(minSel) && !n(maxSel) && 
          (minSel.value != "" || maxSel.value != "") )
      {
        var minAttrId = minSel.value;
        var maxAttrId = maxSel.value;

        var foundMin = minAttrId == "";
        var justFoundMax = false;
        var foundMax = false;
        var sortDir = getRangeSortDirection( setId );

        /* If the sort direction is desc we need to loop through in reverse
           order */
        
        /* The code in the next 2 for loops is reusable so we make a local
           function here. */
        function processRangeQueryValue() {
          if(setNode.childNodes[i].nodeType == 1)
          {
            var c = setNode.childNodes[i];
            var range = getNodeAttribute(c, "desc").split(",");
            
            if(getNodeAttribute(c, "id") === minAttrId)
            { foundMin = true; }
            
            if(getNodeAttribute(c, "id") === maxAttrId)
            {
              if(!foundMin) { foundMax = true; }
              else { justFoundMax = true; }
            }
            
            if(foundMin && (justFoundMax || !foundMax))
            {
              toggleQueryValue(catId,
                               getNodeAttribute(setNode,"id"),
                               getNodeAttribute(c,"id"), 
                               getNodeAttribute(c,"desc"),
                               true);
              if(justFoundMax) { foundMax = true; }
              justFoundMax = false;
            } 
          }
        }
        
        if ( sortDir == "asc" ) {
          for(var i = 0; i < setNode.childNodes.length; i++)
          {
            processRangeQueryValue();
          }
        }
        else {
          for(var i = setNode.childNodes.length - 1; i >= 0; i--)
          {
            processRangeQueryValue();
          }
        }
      }
    }
    else
    {
      toggleQueryValue(catId,
                       getNodeAttribute(setNode,"id"),
                       attrId, 
                       getNodeAttribute(attrNode,"desc"),
                       ADSEARCH.eventElem.checked);
    }
  }

  if(!noUpdate) { updateSelectedFacets(); }
  ADSEARCH.eventElem = null;
}

/*
  Quick wrapper function to provide a way to call a function when 
  the Select all or Select none links are clicked.
*/
function forEachTableInputNode(e, func)
{
  ADSEARCH.eventElem = e.src();
  while(ADSEARCH.eventElem.tagName != "TABLE" && !isUndefinedOrNull(ADSEARCH.eventElem)) 
    { ADSEARCH.eventElem = ADSEARCH.eventElem.parentNode; }
 
  var inputs = ADSEARCH.eventElem.getElementsByTagName("INPUT");
  for(var i = 0; i < inputs.length; i++)
    { func(inputs[i], i == inputs.length - 1); }
  ADSEARCH.eventElem = null;
}

/*
  Generate a fake mochikit event, with only the src() function, 
  and call choose value
*/
function chooseValueWrapper(i)
{
  chooseValue({'src':function(){return i;}},true,true);
}

/* 
  Select all facet values in the checkbox view 
*/
function selectAllValues(e)
{
  var elem = $(getNodeAttribute(e.src(), "scs:target"));
  if(!isUndefinedOrNull(elem))
  { 
    selectAllChildrenCheckboxes(elem,true,chooseValueWrapper); 
    updateSelectedFacets();
  }
  else
  { 
    forEachTableInputNode(e, function(i,up) { setCheckbox(i,true,up); }); 
  }
  stopEvent(e);
}

/* Deselect all facet values in the checkbox view */
function selectNoValues(e)
{
  var elem = $(getNodeAttribute(e.src(), "scs:target"));
  if(!isUndefinedOrNull(elem))
  { 
    selectAllChildrenCheckboxes(elem,false,chooseValueWrapper); 
    updateSelectedFacets();
  }
  else
  { 
    forEachTableInputNode(e, function(i,up) { setCheckbox(i,false,up); }); 
  }
  stopEvent(e);
}

/* Close the checkbox div */
function closeValues(e)
{
  removeElement($(ADSEARCH.FACET_VALUES_DIV));
  stopEvent(e);
}

/*
  Used to launch the AJAX request when the user stopes typing for a second, 
  or when they press enter
*/
function checkKeyPress(e)
{
  window.clearTimeout(ADSEARCH.keyTimeout);

  if(!isUndefinedOrNull(e.event()))
  {
    if(e.event().keyCode == 13)
    {
      ADSEARCH.keyTimeout = window.setTimeout(function(){submitSearch(true);}, 10);
    }
    else
    {
      ADSEARCH.keyTimeout = window.setTimeout(function(){submitSearch(false);}, 1000);
    }
  }
}


/*
  This function toggles the attribute values in the current query.
  The first three parameters indicate the category, set, and 
  attribute id values, the fourth is the descriptive text for the 
  attribute, and and the fifth paremeter is a boolean on whether 
  the value should or shouldn't be present in the query.
*/
function toggleQueryValue(catId,setId,attrId,attrText,value)
{
  var index = getQuerySetIndex(setId);
  if(index >= 0)
  {
    var ag = ADSEARCH.query.attrGroups[index];
    // We have already selected at least one from this set
    if(attrId === ADSEARCH.NS_ATTR)
    {
      // Special not specified option chosen
      ag.ns = value;
      if(!ag.ns && ag.vals.length == 0)
        { ADSEARCH.query.attrGroups.splice(index, 1); }
    }
    else
    {
      var subIndex = getQueryAttrIndex(index, attrId);
      if(value && subIndex < 0)
      {
        // We haven't yet selected this value in the set, so push 
        // it onto the array to be OR'd with the rest
        var obj = { 'id' : attrId, 
                    'desc': attrText };
        ag.vals.push(obj);
      }
      else if(!value && subIndex >= 0)
      {
        ag.vals.splice(subIndex,1);
        if(ag.vals.length == 0 && !ag.ns)
          { ADSEARCH.query.attrGroups.splice(index,1); }
      }
    }
  }
  else if(value)
  {
    // We haven't selected anythign from this set yet, so create
    // an array to hold it
    var obj = {'label':setId, 'vals':[]};

    if(attrId === ADSEARCH.NS_ATTR)
    {
      obj.ns = value;
    }
    else
    {
      obj.vals.push( { 'id':attrId,
                       'desc':attrText } );
    }
    ADSEARCH.query.attrGroups.push(obj);
  }
}

/* 
  Find out what the index of this set is in our query
*/
function getQuerySetIndex(setId)
{
  return objIndexOf( ADSEARCH.query.attrGroups,
                     "label",
                     setId );
}

/* 
  Find out what the index of this attribute is in our query 
*/
function getQueryAttrIndex(setIndex,attrId)
{
  if(setIndex < 0 || setIndex >= ADSEARCH.query.attrGroups.length) 
    { return -1; }
  return objIndexOf( ADSEARCH.query.attrGroups[setIndex].vals,
                     "id",
                     attrId );
}

/*   
  Update the real time view of the current query at the top of 
  the screen, and then launch an AJAx request to update the
  number of ads available.

   - initialCat - this is a boolean parameter indicating whether 
     this is the initial search for a category leaf node 
     (like Cars/Trucks/For Rent).  If so, we pass this information 
     all the way to the ajax request, because we need to save off 
     our Valid Values separately as the entire set of valid values 
     in the database
*/
function updateSelectedFacets(initialCat)
{
  if(isUndefinedOrNull(initialCat)) { initialCat = false; }

  // Launch the AJAX request first, then while that is in the 
  // network, we draw the selected facets div.
  submitSearch(false, initialCat);

  // Now begin drawing the div
  var div = $('selected_values');
  replaceChildNodes(div);
 
  var a = A({'href':'#','class':'scs_b','scs:cat':'root'}, getNodeAttribute(ADSEARCH.rootNode, "desc"));
  connect(a,"onclick",revertToFacet);
  appendChildNodes(div, a);
  
  if(ADSEARCH.query.levels.length > 0) 
    { appendChildNodes(div, " > "); }

  var facetPath = "";

  for(var i = 0; i < ADSEARCH.query.levels.length; i++)
  { 
    var l = ADSEARCH.query.levels[i];
    facetPath += ((facetPath != "")?":":"") + l.id;
    var a = A({'href':'#','class':'scs_b','scs:cat':facetPath}, l.desc);
    connect(a,"onclick",revertToFacet);
    appendChildNodes(div, a);
    if( i < ADSEARCH.query.levels.length-1 || 
        ADSEARCH.query.attrGroups.length > 0 )
      { appendChildNodes(div, " > "); }
  }

  for(var i = 0; i < ADSEARCH.query.attrGroups.length; i++)
  {
    // Create a span of the attribute values selected in this set
    var ag = ADSEARCH.query.attrGroups[i];
    var span = SPAN();
   
    // If we're a range, let's first sort ourself
    if(setIsRange(ag.label)) 
    { 
      ag.vals.sort(cmpRange); 

      var min = ag.vals[0].desc.split(",")[0];
      var max = ag.vals[ag.vals.length-1].desc.split(",")[1];

      if(min === "" || parseInt(min,10) === 0) 
        { appendChildNodes(span, "Less than " + getFormattedValue(ag.label, max, true)); }
      else if(max == "") 
        { appendChildNodes(span, "Greater than " + getFormattedValue(ag.label, min, true)); }
      else
        { appendChildNodes(span, getFormattedValue(ag.label, min, false) + " - " + getFormattedValue(ag.label, max, true)); }
    }
    else
    {
      for(var j = 0; j < ag.vals.length; j++)
      { 
        appendChildNodes(span, ag.vals[j].desc);
        if(j < ag.vals.length-1) { appendChildNodes(span, "/"); }
      }

      if(ag.ns) 
      { 
        if(ag.vals.length > 0) { appendChildNodes(span, "/"); }
        appendChildNodes(span, ADSEARCH.NS_TEXT); 
      }

      // Let's trim down the displayed part and add an overlib to 
      // show the entire thing.
      if(span.innerHTML.length > 15)
      {
        var longStr = span.innerHTML;
        var shortStr = longStr.substring(0,10);
        var hoverLink = SPAN({'style':'text-decoration:none;color:blue;cursor:pointer;'},"...");
        overlibConnect(hoverLink, longStr);
        replaceChildNodes(span, shortStr, hoverLink);
      }
    }

    // Give the user a way to remove this restriction
    var closeLink = SPAN({'style':'text-decoration:none;color:blue;cursor:pointer;',
                          'scs:for':ag.label},"[X]");
    overlibConnect(closeLink, ADSEARCH.REMOVE_TEXT);
    connect(closeLink, "onclick", removeFacetValues);
    appendChildNodes(span, " ", closeLink);

    appendChildNodes(div,span);

    if(i < ADSEARCH.query.attrGroups.length-1) 
      { appendChildNodes(div,", "); }
  }

  if(isUndefinedOrNull($('num_results_span'))) 
    { appendChildNodes(div, SPAN({'id':'num_results_span'}," (Searching...)")); }
}

/*
  Function executes when a user click on a category in the qurrent 
  query, idicating they weant to go back to that step.  This needs
  to clear all selected attribute values, and all subcategories, 
  and then process this category node as usual, presenting ther user
  with a sdelect box of sub categories,. or the appropriate view 
  of spanning sets
*/
function revertToFacet(e)
{
  ADSEARCH.eventElem = e.src();
  var cat = getNodeAttribute(ADSEARCH.eventElem, "scs:cat");

  var node;
  if(cat === "root")
  {
    node = ADSEARCH.rootNode;
    resetAdsearchDefaults();
    processNode(node, false);
  }
  else
  {
    var facets = cat.split(":");
    var currNode = ADSEARCH.rootNode;
    var newQuery = { 'levels' : [] , 'attrGroups' : [] };
    for(var i = 0; i < facets.length; i++)
    {
      facets[i] = { 'tagName' : ADSEARCH.TYPE_CATEGORY,
                    'id'      : facets[i] };
      newQuery.levels.push(ADSEARCH.query.levels[i]);
    }

    resetAdsearchDefaults();
    ADSEARCH.query = newQuery;    

    var node = findDescendant(currNode, facets);
    if(isUndefinedOrNull(node))
      { return false; }


    if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_LEFT_BODY)
    {
      // If in this layout mode, we need to draw the root teee, 
      // and manually expand it down to this category
      processNode(ADSEARCH.rootNode, false);
      expandTree(facets);
    }
    else
    {
      processNode(node, false);
    }
  }

  updateSelectedFacets();
  ADSEARCH.eventElem = null;
}

function removeFacetValues(e)
{
  // First, call nd() because were going to remove this span, 
  // and the onmouseout is never going to fire
  nd();

  ADSEARCH.eventElem = e.src();
  var attr = getNodeAttribute;

  if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_ROW_TAB)
  {
    var tblDiv = $(ADSEARCH.FACET_VALUES_DIV);
    if( !isUndefinedOrNull(tblDiv) && 
        attr(tblDiv, "scs:set") == attr(ADSEARCH.eventElem, "scs:for") )
    {
      closeValues();
    }
  }
  else if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_LEFT_BODY)
  {
    var ul = $(getNodeAttribute(ADSEARCH.eventElem, "scs:for"));
    var subdiv = $(getNodeAttribute(ADSEARCH.eventElem, "scs:for")+"_sub");
    if( !isUndefinedOrNull(ul) && 
        !isUndefinedOrNull(subdiv) && 
        !hasElementClass(subdiv,"scs_hidden") )
    {
      var lis = ul.getElementsByTagName("LI");
      if(lis.length > 0)
        { drillDown(lis[0]); }
    } 
  }

  ADSEARCH.query.attrGroups.splice(getQuerySetIndex(getNodeAttribute(ADSEARCH.eventElem, "scs:for")), 1);
  updateSelectedFacets();
  ADSEARCH.eventElem = null;
}

/*
  recursive function to find a descendant noded based 
  on the path identified in childArr
*/
function findDescendant(pNode, childArr, depth)
{  
  if(isUndefinedOrNull(depth)) 
    { depth = 0 };

  // End recursion if we need to
  if( depth >= childArr.length ) { return pNode; }
  else if( isUndefinedOrNull(pNode) || 
           pNode.childNodes.length == 0 || 
           depth > childArr.length ) {return null;}

  for(var i = 0; i < pNode.childNodes.length; i++)
  {
    var c = pNode.childNodes[i];
    if(c.nodeType == 1 && compareNodeAttributes(c, childArr[depth]))
    {
      var ret = findDescendant(c, childArr, depth+1);
      if(ret !== null) { return ret; }
    }
  }
  return null;
}

/*
  Function to expand outr drill down tree to the node 
  specified by the path in childArr
*/
function expandTree(childArr, depth)
{  
  if(isUndefinedOrNull(depth)) 
    { depth = 0 };

  // End recursion if we need to
  if( depth >= childArr.length || depth > childArr.length) 
    {return null;}

  var ul = $(childArr[depth].id);
  
  if(isUndefinedOrNull(ul) || ul.tagName !== "UL")
    { return null; }
 
  var lis = ul.getElementsByTagName("LI");
  if(lis.length <= 0) 
    { return null; }
 
  processNodeWrapper({'src':function() { return lis[0]; }});
  drillDown(lis[0]);
  
  var ret = expandTree(childArr, depth+1);

  if(ret !== null) { return ret; }
  return null;
}

function submitCategoryFacet(key_id)
{
  // Add this to our global query object
  var catNode = getElementByIdXML(ADSEARCH.rootNode, key_id, ADSEARCH.TYPE_CATEGORY);
  var desc = getNodeAttribute(catNode, "desc");
  ADSEARCH.query.levels.push({ 'id'   : key_id, 
                               'desc' : desc });
  updateSelectedFacets();
}

/*
  This is simply to get the label for a given node, so that
  language translation can be handled in one spot.
*/
function getLabelSpan(node)
{
  return SPAN({'class':'obj_b'},
              "Please choose a " + 
               getNodeAttribute(node,"desc") + ":  ");
}

/*
  This function returns a submit button for the input with 
  the given id
*/
function getSubmitButton(id,text,func)
{
  var btn = INPUT({ 'id' : id + '_btn',
                    'type'    : 'button',
                    'scs:for' : id,
                    'value'   : text }, null);
  connect(btn, "onclick", func);
  return btn;
}


/*
  Function to launch the AJAX request for a query.  if fillTable is
  TRUE, then we will actually run the query and bring back results.
  Otherwise, we only want to know how many ads there are in this 
  current query.

  - fillTable: TRUE if we should create and fill the SCs Table.  
               FALSE if we only want to fnid out how many ads 
               match the current query
  - preserveValues: TRUE if we should save off the valid values 
                    returned from this AJAX request to 
                    ADSEARCH.catValidVals, indicating that those 
                    are all of the values present in the databsse 
                    for this category leaf node
*/
function submitSearch(fillTable, preserveValues)
{ 
  if(isUndefinedOrNull(fillTable)) { fillTable = false; }
  if(isUndefinedOrNull(preserveValues)) { preserveValues = false; }

  var query = "";
  var i;

  // Add in the levels for the query
  for(i = 0; i < ADSEARCH.query.levels.length; i++)
  {
    var lvl = ADSEARCH.query.levels[i];
    query += "Level" + (i+1) + ":" + lvl.id;
    if(i < ADSEARCH.query.levels.length -1) { query += " AND "; }
  }

  var posQuery = "";
  var negQuery = "";

  // Construct the boolean string of attribute values
  for(i = 0; i < ADSEARCH.query.attrGroups.length; i++)
  {
    var ag = ADSEARCH.query.attrGroups[i];

    //query += " AND Attributes:(";

    if(ag.vals.length > 0 || ag.ns) 
    { 
      if(posQuery.length > 0) { posQuery += " AND "; }
      posQuery += " Attributes:("; 
    }

    /* If not specified, add in the unrec_ attribute */
    posQuery += ( ag.ns ) ? "unrec_" + ag.label : "";
    posQuery += (ag.ns && ag.vals.length > 0) ? " OR " : " "

    for(var j = 0; j < ag.vals.length; j++)
    {
      posQuery += " " + ag.vals[j].id + " ";
      if(ag.label == ADSEARCH.TYPE_OTHER &&  j < ag.vals.length-1) 
        { posQuery += " AND "; } 
      else if(ag.label != ADSEARCH.TYPE_OTHER && j < ag.vals.length-1) 
        { posQuery += " OR "; } 
    }

    if(ag.vals.length > 0 || ag.ns) { posQuery += ") "; }
    
    //if(ag.label != ADSEARCH.TYPE_OTHER) { query += " )"; }

    //if(i < ADSEARCH.query.attrGroups.length-1) 
    //  { query += " AND "; }
  }

  if(negQuery !== "" && posQuery !== "")
    { query += " AND " + negQuery + " OR " + posQuery; }
  else if(posQuery !== "")
    { query += " AND " + posQuery; }
  else if(negQuery !== "")
    { query += " AND " + negQuery; }

  //if(ADSEARCH.query.attrGroups.length > 0)
  //  { query += " )"; }

  // If there is any text from the user, add that also
  if(trim($('textsrch').value) != "")
  {
    var txt = booleanizeString(trim($('textsrch').value));
/*      logToPage(txt); */

    var lastChar = txt.substring( txt.length - 1 );
    if ( ( ! fillTable ) &&
         ( lastChar != '"' ) &&
         ( lastChar != '*' ) &&
         ( lastChar != ')' ) &&
         ( lastChar != '(' ) &&
         ( lastChar != ' ' ) )
      { txt += "*"; }

    query += (query == "" ? "" : " AND ") + "Contents: (" + txt + ")";
  }
  
  // If the query is still blank, get everything
  if(trim(query) == "")
  {
    query = "";
    for(var i = 0; i < ADSEARCH.rootNode.childNodes.length; i++)
    {
      var c = ADSEARCH.rootNode.childNodes[i];
      if(c.nodeType == 1 && c.tagName == ADSEARCH.TYPE_CATEGORY)
      {
        query += (query == "" ? "" : " OR ") + 
                 "Level1:" + getNodeAttribute(c, "id"); 
      }
    }
  }

  ajaxRequest(query, fillTable, preserveValues);
}

function ajaxRequest(query, fillTable, preserveValues)
{
  addElementClass(document.body, "progress");

  var alwaysCallback = function(lrm) 
    { 
      removeElementClass(document.body, "progress");
      ADSEARCH.chooseValueLock = false;
    };

  var reusableCallback;

  if(!preserveValues)
  {
    reusableCallback = alwaysCallback;
  }
  else
  {
    reusableCallback = function(lrm) 
      { 
        alwaysCallback(lrm);
        ADSEARCH.catValidVals = ADSEARCH.validVals;
      };
  }

  var reusableErrback = function(lrm)
  {
    reusableCallback(lrm)
    defaultErrorCallback(lrm);
  }
  
  // Launch the AJAX request
  if(fillTable)
  {
    var myCallback = function( obj, res ) { 
      updateNumResults( obj.NumResults );
      updateValidVals( obj );
      updateValidLeftBodyValues();
      updateColumnMappings( obj );
      var jsCode = obj.TableJS;
      eval( jsCode );
      if( !isUndefinedOrNull( sT_adsearch ) ) {
        var element = sT_adsearch.getSortableTableElement();
        if ( !isUndefinedOrNull( element ) ) {
          replaceChildNodes( element );
        }
        sT_adsearch.buildSortableTable( true );
        sT_adsearch.loadFromURL2( "spice.pl?command=getsrchresults" );
      }
      reusableCallback( obj );
    };
    getJSON( "perform_search", myCallback, { 'querystring': query } );
  }
  else
  {
    // Dont get valid values is we're still at the category level.  
    // This means were searching for multiple Level1 categories, 
    // so we can look for "OR Level1"
    var getValidVals = (query.indexOf("OR Level1:") < 0) ? true : false;
    var params = { 'querystring': query,
                   'validvals': getValidVals };

    var myCallback = function( obj ) {
      updateNumResults( obj.NumResults );
      updateValidVals( obj );
      updateValidLeftBodyValues()
      reusableCallback( obj );
    };

    getJSON( "getnumresults", myCallback, params );
  }
}

function updateValidVals( obj )
{
  ADSEARCH.validVals = {};
  var validVals = obj.ValidValues;
 
  forEach( keys( validVals ),
           function( c ) {
             ADSEARCH.validVals[c] = [];
             if ( validVals[c] ) {
               var values = validVals[c].split( "," );
               forEach( values,
                        function( v ) {
                          ADSEARCH.validVals[c][v] = true;
                        } );
             }
           } );
}

function updateValidLeftBodyValues()
{
  // Now that we have a new set of valid values, we need to 
  // update any checkboxes already on the screen, since they 
  // would otherwise not get updated until the expandable 
  // div was closed and then opened
  if(ADSEARCH.LAYOUT == ADSEARCH.LAYOUT_FACET_LEFT_BODY)
  {
    var attr = getNodeAttribute;
    var n = isUndefinedOrNull;
    var frame = $("upper_left_body");
    var labels = frame.getElementsByTagName("LABEL");
    forEach(labels, function(lbl)
    {
      var input = $(attr(lbl, "for"));
      if( !n(input) && 
          input.tagName.toUpperCase() === "INPUT" &&
          attr(input, "type") === "checkbox" )
      {
        var setId = attr(input, "scs:set");
        if(setId === ADSEARCH.TYPE_OTHER) 
        {
          var attrId = attr(input, "value");
          var index = getQuerySetIndex(setId);
          var hasNs = (index >= 0 && ADSEARCH.query.attrGroups[index].ns);

          // If we have no specified for this spanning set, or if 
          // we are a valid value, enable ourselves
          if(hasNs || isValidVal(setId, attrId))
          {
            enableCheckbox(input);
            enableLabel(lbl);
          }
          // Otherwise disable ourselves (except if we are a Not Specified checkbox)
          else if(attrId !== ADSEARCH.NS_ATTR) 
          {
            disableCheckbox(input);
            disableLabel(lbl);
          }
        }
      }
    });
  }
}
 
function updateColumnMappings( obj ) {
  var colMaps = obj.ColumnMaps;
  ADSEARCH.colMaps = {};

  forEach( keys( colMaps ),
           function( c ) {  
             ADSEARCH.colMaps[c] = colMaps[c];
           } );
}

function booleanizeString(txt)
{
  // Extract any quotes strings as tokens
  var tokens = [];
  var in1, in2;
  in1 = txt.indexOf('"');
  in2 = txt.indexOf('"', in1+1);
  while(in1 >= 0 && in2 >= 0)
  {
    var toksBefore = txt.substring(0, in1).split(" ");
    forEach(toksBefore, function(t){if(trim(t) != "") {tokens.push(t);}});
    tokens.push(txt.substring(in1+1, in2));
    txt = txt.substring(in2+1);
    in1 = txt.indexOf('"');
    in2 = txt.indexOf('"', in1+1);
  }
  var toksBefore = txt.split(" ");
  forEach(toksBefore, function(t){if(trim(t) != "") {tokens.push(t);}});

  // Now contruct the tokens into a boolean string
  txt = "";
  for(var i = 0; i < tokens.length; i++)
  {
    if(tokens[i].indexOf(" ") >= 0) 
      { tokens[i] = '"' + tokens[i] + '"'; }

    if(i < tokens.length - 1)
    {
      if(trim(tokens[i]) == "(")
      { 
        if(tokens[++i].indexOf(" ") >= 0) 
          { tokens[i] = '"' + tokens[i] + '"'; }
        tokens[i] = "(" + tokens[i]; 
      }
      if(trim(tokens[i+1]) == ")")
      { 
        if(tokens[++i].indexOf(" ") >= 0) 
          { tokens[i] = '"' + tokens[i] + '"'; }
        tokens[i] = tokens[i-1] + ")"; 
      }

      if( trim(tokens[i+1]).toUpperCase() == "AND" || 
          trim(tokens[i+1]).toUpperCase() == "&&" )
      {
        txt += tokens[i++] + " AND ";
      }
      else if( trim(tokens[i+1]).toUpperCase() == "OR" ||
               trim(tokens[i+1]).toUpperCase() == "||" )
      {
        txt += tokens[i++] + " OR ";
      }
      else
      {
        txt += tokens[i] + " AND ";
      }
    }
    else
    {
      txt += tokens[i];
    }
  }

  return txt;
}

function updateNumResults(num)
{
  if(num >= 0)
  {
    replaceChildNodes($('num_results_span'), "   (" + num + " ads)");
    Highlight($('num_results_span'));
  }
}

function disableCheckbox(i)
{
  setNodeAttribute(i, "disabled", "disabled");
  i.disabled = true;
}

function enableCheckbox(i)
{
  i.removeAttribute("disabled");
  i.disabled = false;
}

function disableLabel(l)
{
  setStyle(l, {'text-decoration' : 'line-through'});
}

function enableLabel(l)
{
  setStyle(l, {'text-decoration' : 'none'});
}

function simpleSetCheckbox(i,val,update)
{
  i.checked = val;
  if(val) 
    { setNodeAttribute(i, "checked", "true"); }
}

function setCheckbox(i, val, update)
{
  simpleSetCheckbox(i, val, update);

  chooseValue({'src': function(){return i;}}, !update);
}

function clearQuerySet(setId)
{
  var index = objIndexOf( ADSEARCH.query.attrGroups,
                          "label",
                          setId );
  if(index >= 0)
  {
    ADSEARCH.query.attrGroups.splice(index, 1);
    return true;
  }
  return false;
}

/*
  Function to pass to Array.sort() to sort an array of range values:

    [ "200,299", "100,199", "300,399" ]

  will be sorted to:

    [ "100,199", "200,299", "300,399" ]

  Note that it sorts of the numerical value of the 
  portion before the comma .
*/
function cmpRange(a,b)
{
  var getVal = function(str) 
  { 
    if(isUndefinedOrNull(str) || str === "")
      { return 10000000000000; }
    return parseInt(str.split(",")[0],10); 
  }
  return compare(getVal(a.desc), getVal(b.desc));
}

function setIsRange(setId)
{
  return booleanXPATHQuery(ADSEARCH.configXMLDoc, 
                           "/" + ADSEARCH.TYPE_CONFIG + 
                           "/" + ADSEARCH.TYPE_RANGES + 
                           "/" + setId);
}

function getRangeSortDirection( setId )
{
  var nodes = evalXPATHQuery( ADSEARCH.configXMLDoc, 
                              "/" + ADSEARCH.TYPE_CONFIG +
                              "/" + ADSEARCH.TYPE_RANGES +
                              "/" + setId );
  if ( nodes.length == 1 ) {
    var sortDir = getNodeAttribute( nodes[0], ADSEARCH.ATTR_SORT );
    if ( isUndefinedOrNull( sortDir ) ) {
      sortDir = "asc";      
    }
  }
  
  return sortDir;
}

function getAttrObj(node)
{
  return { 'id' : getNodeAttribute(node, "id"),
           'desc' : getNodeAttribute(node, "desc") };
}

function hideSetInvalidVals(setId)
{
  var nodes = evalXPATHQuery(ADSEARCH.configXMLDoc, 
                             "/" + ADSEARCH.TYPE_CONFIG +
                             "/" + ADSEARCH.TYPE_HIERARCHIES + 
                             "/" + setId);

  for(var i = 0; i < nodes.length; i++)
  {
    var parent = getNodeAttribute(nodes[i], ADSEARCH.ATTR_PARENT);
    if(getQuerySetIndex(parent) >= 0)
      { return true; }
  }
  return false;
}

function sharedIsValidVal(obj,setId, attrId)
{
  var n = isUndefinedOrNull;
  return n(obj) || (!n(obj[setId]) && obj[setId][attrId]);

  // Note: If obj (ADSEARCH.validVals is null, then we haven't yet 
  // populated it with our first AJAX request, so we must assume 
  // everything is valid.
}

function isValidVal(setId, attrId)
  { return sharedIsValidVal(ADSEARCH.validVals, setId, attrId); }

function isCatValidVal(setId, attrId)
  { return sharedIsValidVal(ADSEARCH.catValidVals, setId, attrId); }

function getFormattedValue(setId, val, show)
{
  var n = isUndefinedOrNull;
  if(n(show)) { show = false; }
  var results = evalXPATHQuery(ADSEARCH.configXMLDoc, 
                               "/" + ADSEARCH.TYPE_CONFIG +
                               "/" + ADSEARCH.TYPE_RANGES + 
                               "/" + setId + 
                               "|" +
                               "/" + ADSEARCH.TYPE_CONFIG +
                               "/" + ADSEARCH.TYPE_NUMERIC + 
                               "/" + setId);
  if(results.length > 0)
  {
    // Node is numeric
    var format = "###";

    results = evalXPATHQuery(ADSEARCH.configXMLDoc,
                             "/" + ADSEARCH.TYPE_CONFIG +  
                             "/" + ADSEARCH.TYPE_FORMATS +  
                             "/" + setId);
    if(results.length > 0)
    {
      var prefix = getNodeAttribute(results[0], ADSEARCH.ATTR_PREFIX);
      var suffix = getNodeAttribute(results[0], ADSEARCH.ATTR_SUFFIX);
      var delim = getNodeAttribute(results[0], ADSEARCH.ATTR_DELIM);
      show = show || (getNodeAttribute(results[0], ADSEARCH.ATTR_SHOW) === "y");
 
      if(!n(delim)) { format += delim + "###"; }
      if(!n(prefix) && show) { format = prefix + format; }
      if(!n(suffix) && show) { format = format + suffix; }
    }

    if ( !isUndefinedOrNull( val ) ) {
      val = numberFormatter(format)(val);
    }
    return val;
  }

  return val;
}

function addTableLinks(td, setId, val)
{
  var n = isUndefinedOrNull;

  // Now try for links
  results = evalXPATHQuery(ADSEARCH.configXMLDoc,
                           "/" + ADSEARCH.TYPE_CONFIG + 
                           "/" + ADSEARCH.TYPE_LINKS + 
                           "/" + setId);
  
  if(results.length > 0)
  {
    var type = getNodeAttribute(results[0], ADSEARCH.ATTR_TYPE);
    if(type === ADSEARCH.VAL_HREF)
    {
      var prefix = getNodeAttribute(results[0], ADSEARCH.ATTR_PREFIX);
      var suffix = getNodeAttribute(results[0], ADSEARCH.ATTR_SUFFIX);

      var href = val;
      if(!n(prefix)) { href = prefix + href; }
      if(!n(suffix)) { href += suffix; }

      replaceChildNodes(td, A({'href':href}, val));
    }
    else if(type === ADSEARCH.VAL_ONCLICK)
    {
      var func = getNodeAttribute(results[0], ADSEARCH.ATTR_FUNC);
      
      if(typeof window[func] === "function")
      {
        var link = A(null, val);
        connect(link, "onclick", function(e) { window[func](e,val); });
        addElementClass(link, "scs_link");
        replaceChildNodes(td, link);
      }
    }
  }
                           
  return td;
}

function tableLoadEventFunc(td, table, col, row)
{
  var n = isUndefinedOrNull;

  var val = row[col.cId];  // My text value

  var aql = ADSEARCH.query.levels;

  if(aql.length > 0)
  {
    var catId = aql[aql.length-1].id;
    var catNode = getElementByIdXML(ADSEARCH.rootNode, catId, ADSEARCH.TYPE_CATEGORY);
    var setNode = getElementByIdXML(catNode, ADSEARCH.colMaps[col.cId], ADSEARCH.TYPE_SET);

    // If we didn't find it, let's look by range.  This can go away 
    // once we implement the config file.
    if(n(setNode))  
    {
      var setId = ADSEARCH.RANGE_PREFIX + ADSEARCH.RANGE_SEP + ADSEARCH.colMaps[col.cId];
      setNode = getElementByIdXML(catNode, setId, ADSEARCH.TYPE_SET);
    }

    if(!n(setNode))
    { 
      var replace = false;
      var attrNode = getElementByIdXML(setNode, val, ADSEARCH.TYPE_ATTR);
      if(!n(attrNode))
      { 
        var val_attrs = getAttrObj(attrNode);
        if(val !== val_attrs.desc)
        {
          val = val_attrs.desc;
          replace = true;
        }
      }

      var set_attrs = getAttrObj(setNode);

      var newVal = getFormattedValue(set_attrs.id, val, false);
      if(newVal !== val || replace)
        { replaceChildNodes(td, newVal); }

      td = addTableLinks(td, set_attrs.id, newVal);
    }

  }

  // Not used for now.  Adds a left border to any AttrField columns, so 
  // they stand out better when there are a lot of blanks.
  // setStyle(td, { 'border-left' : '1px solid gray' });

  return td;
}
